import { SVGProps } from 'react';

export const VendorCall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26191 11.2381H8.88095C9.17062 11.2381 9.40476 11.004 9.40476 10.7143V8.61909C9.40476 8.32942 9.17062 8.09528 8.88095 8.09528H6.78571C6.49605 8.09528 6.26191 8.32942 6.26191 8.61909V9.1429C4.16667 9.1429 2.62824 7.53899 2.59524 5.47623H3.11905C3.40871 5.47623 3.64286 5.24209 3.64286 4.95242V2.85718C3.64286 2.56752 3.40871 2.33337 3.11905 2.33337H1.02381C0.734143 2.33337 0.5 2.56752 0.5 2.85718V5.47623C0.5 8.65837 3.07976 11.2381 6.26191 11.2381Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.35734 3.24553L11.1529 1.97487L8.48494 0.78907C8.40354 0.752927 8.31114 0.752927 8.22974 0.78907L5.56177 1.97487L8.35734 3.24553Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.04293 3.79282L5.21436 2.50708V5.47614C5.21436 5.60059 5.28758 5.71311 5.40104 5.76371L8.04293 6.93788V3.79282Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.67139 3.79282V6.93788L11.3133 5.76371C11.4267 5.71311 11.5 5.60059 11.5 5.47614V2.50708L8.67139 3.79282Z"
      fill="currentColor"
    />
  </svg>
);
